import * as CustomCodeActionMetadataKeys from 'automation-ui-action-features/actions/custom-code/constants/CustomCodeActionMetadataKeys';
/**
 * actionTypeId is a property on both the action and the CCA metadata, before saving we want to make sure we
 * update both with the most recent value from the draft endpoints
 * @param {Object} action - actionTypeId returned from updating the draft
 *
 * @returns {Object} the action with actionTypeIds set
 */
export const setActionTypeId = (actionTypeId, action) => {
  let updatedAction = action.set('actionTypeId', actionTypeId);
  updatedAction = updatedAction.updateMetadata(metadata => metadata.set(CustomCodeActionMetadataKeys.ACTION_TYPE_ID, actionTypeId));
  return updatedAction;
};